/* CT 2026-09-23 (noche) — CANTIDADES CON DECIMALES: MENSAJE EN ESPAÑOL, NO EL DE SHOPIFY.
 *
 * El caso: en el carrito, escribir 1.5 en la cantidad mandaba el valor al servidor y Shopify
 * contestaba en INGLES — "expected String to be a Integer: quantity" — y el tema lo mostraba tal
 * cual debajo de la linea. En la ficha, 2.5 daba "Tu carrito ya tiene la cantidad maxima de este
 * articulo", que esta en español pero es FALSO (el problema es el decimal, no el tope).
 * Regla de Camilo: ningun texto visible para el cliente en ingles.
 *
 * Lo que hace, en todas las paginas y en PC tambien (el ingles salia igual):
 *   · Frena ANTES de que el valor viaje: si la cantidad no es un entero, el cambio no llega al
 *     tema (se detiene el evento en la fase de captura), la caja vuelve al ultimo valor valido y se
 *     muestra "La cantidad debe ser un número entero, sin decimales" donde el tema pone sus errores.
 *   · Lo mismo al agregar desde la ficha: si la cantidad tiene decimales, no se envia.
 *   · A las cajas de cantidad les pone `inputmode="numeric"` y `step="1"`: en el telefono sale el
 *     teclado de numeros, sin coma ni punto. Es presentacion; la logica del carrito no cambia.
 */
(() => {
  const MENSAJE = 'La cantidad debe ser un número entero, sin decimales';
  const SELECTOR = 'input[name="updates[]"], input[name="quantity"], .quantity__input';
  const entero = v => /^\s*\d+\s*$/.test(String(v));

  const preparar = raiz => {
    raiz.querySelectorAll(SELECTOR).forEach(i => {
      i.setAttribute('inputmode', 'numeric');
      i.setAttribute('step', '1');
      if (entero(i.value)) i.dataset.ctUltimo = i.value.trim();
    });
  };
  preparar(document);
  // El tema vuelve a dibujar las lineas del carrito al cambiar una cantidad: se preparan otra vez.
  // Se observa SOLO la lista del carrito, no el <body>: el INP de la tienda esta en seguimiento y un
  // observador sobre toda la pagina correria en cada cambio de cualquier cosa.
  const lista = document.getElementById('main-cart-items');
  if (lista && 'MutationObserver' in window) new MutationObserver(() => preparar(lista)).observe(lista, { childList: true, subtree: true });

  const mostrar = (input, texto) => {
    const linea = input.closest('.cart-item');
    if (linea) {
      const caja = linea.querySelector('.cart-item__error');
      const txt = linea.querySelector('.cart-item__error-text');
      if (caja && txt) { txt.textContent = texto; caja.classList.remove('hidden'); return; }
    }
    const form = input.closest('product-form, form');
    const err = form && (form.querySelector('.product-form__error-message') || (form.closest('product-form') && form.closest('product-form').querySelector('.product-form__error-message')));
    const envoltura = err && err.closest('.product-form__error-message-wrapper');
    if (err) { err.textContent = texto; if (envoltura) envoltura.hidden = false; return; }
    if (typeof pushErrorMessage === 'function') pushErrorMessage(texto);
  };
  const limpiar = input => {
    const linea = input.closest('.cart-item');
    const caja = linea && linea.querySelector('.cart-item__error');
    if (caja) caja.classList.add('hidden');
  };

  // 1) Carrito (y cualquier caja de cantidad): el tema escucha `change` en <cart-items>. Se corta en
  //    la captura, en `document`, que corre ANTES.
  document.addEventListener('change', e => {
    const i = e.target;
    if (!i || !i.matches || !i.matches(SELECTOR)) return;
    if (entero(i.value)) { i.dataset.ctUltimo = i.value.trim(); limpiar(i); return; }
    e.stopImmediatePropagation();
    e.preventDefault();
    i.value = i.dataset.ctUltimo || i.defaultValue || '1';
    mostrar(i, MENSAJE);
  }, true);

  // 2) Ficha: el envio de <product-form>.
  document.addEventListener('submit', e => {
    const f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    const i = f.querySelector('input[name="quantity"]') || (f.id && document.querySelector('input[name="quantity"][form="' + f.id + '"]'));
    if (!i || entero(i.value)) return;
    e.stopImmediatePropagation();
    e.preventDefault();
    mostrar(i, MENSAJE);
  }, true);
})();
